export enum Roles {
	ADMIN = 'admin',
	ANALYST = 'analyst',
	ANALYST_DS_CA = 'analyst_ds_ca',
	SUPER_ADMIN = 'superadmin',
	RUKOVODITEL = 'rukovoditel',
	MANAGER = 'manager',
	HEAD_MANAGER = 'head_manager',
	BLOCK_CORRECTOR = 'korrektirovschik-blokirovok',
	TECH_SUPPORT = 'tech_support',
	EDITOR = 'editor',
	PURCHASER = 'purchaser',
	TERMEN = 'territorialnyy-menedzher',
	REGMEN = 'regionalnyy-menedzher',
	MANAGER_DS = 'manager-ds',
	QA_EXPERT = 'qa_expert',
	REGISTRAR = 'registrar',
	PILOT = 'pilot',
	PILOT_ONLINE = 'pilot_online',
	PILOT_SIGNER = 'pilot_signer',
	PILOT_BANK = 'pilot_bank',
	PILOT_REDESIGN = 'pilot_redesign',
	PILOT_RESERVE = 'pilot_reserve',
	PILOT_CABINET = 'pilot_cabinet',
	PILOT_PAID = 'pilot_paid',
	CLIENT_IDENTIFIER = 'client_identifier',
	REGISTRAR_DS = 'registrar_ds',
	TECH_SUPPORT_LINE_1 = 'tech_support_line_1',
	ACCOUNTANT = 'accountant',
	RUKOVODITEL_DS_CA = 'boss_ds_ca',
	RUN = 'run',
	HEAD_GOVERNANCE = 'head_governance',
	HEAD_SECTOR = 'head_sector',
	SENIOR_MANAGER = 'senior_manager',
	SBER_MANAGER = 'menedzher-sberbanka',
	SECURITY = 'security',
	MENEDZHER_SBERBANKA = 'menedzher-sberbanka',
	BIZNES_ADMINISTRATOR = 'biznes-administrator',
	SPECIALIST_CC = 'specialist_cc',
	PRODUCT_SPECIALIST = 'product_specialist',
	EXAM_SURVEY_EDITOR = 'exam_survey_editor ',
	CURATOR_KES = 'curator_kes',
	SOTRUDNIK_BANK = 'sotrudnik-bank',
	RUKOVODITEL_BANK = 'rukovoditel-bank',
	SBER_TELECOM = 'sber_telecom',
	POTENTIAL_PARTNER = 'potential_partner',
	DEVELOPER = 'developer',
	TMPP_GR = 'tmpp_gr',
}

export const RolesHasStartPage: Roles[] = [
	Roles.ADMIN,
	Roles.SUPER_ADMIN,
	Roles.TERMEN,
	Roles.REGMEN,
	Roles.MANAGER_DS,
	Roles.QA_EXPERT,
	Roles.RUKOVODITEL_DS_CA,
	Roles.REGMEN,
	Roles.SENIOR_MANAGER,
	Roles.HEAD_GOVERNANCE,
	Roles.HEAD_SECTOR,
	Roles.EDITOR,
	Roles.SPECIALIST_CC,
	Roles.PRODUCT_SPECIALIST,
	Roles.CURATOR_KES,
	Roles.DEVELOPER,
]

export const TEST_ROLES_DRS = [
	Roles.ADMIN,
	Roles.SUPER_ADMIN,
	Roles.MANAGER,
	Roles.HEAD_MANAGER,
	Roles.RUKOVODITEL,
]

export const ROLES_DRS = [
	Roles.TERMEN,
	Roles.REGMEN,
	Roles.SENIOR_MANAGER,
	Roles.QA_EXPERT,
	Roles.PRODUCT_SPECIALIST,
	Roles.ANALYST_DS_CA,
	Roles.TECH_SUPPORT,
	Roles.TECH_SUPPORT_LINE_1,
	Roles.HEAD_GOVERNANCE,
	Roles.HEAD_SECTOR,
]

export const ADMIN_ROLES = [Roles.ADMIN, Roles.SUPER_ADMIN, Roles.MANAGER_DS]

export const OBSERVERS_ROLES = [
	Roles.TERMEN,
	Roles.REGMEN,
	Roles.SENIOR_MANAGER,
	Roles.MENEDZHER_SBERBANKA,
].join(',')
